import axios from "axios";

const baseURL = process.env.VUE_APP_API_ENDPOINT

export default axios.create({
  baseURL
})

